import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CompaniesListComponent } from './companies-list';
import {NgPipesModule} from 'ngx-pipes';

@NgModule({
  declarations: [
    CompaniesListComponent,
  ],
  imports: [
    IonicModule,
    NgPipesModule,
  ],
  exports: [
    CompaniesListComponent
  ]
})
export class CompaniesListComponentModule {}



// WEBPACK FOOTER //
// ./src/components/companies-list/companies-list.module.ts